import { US_MARKET } from '../constants';

export const prepareDealerIdToGetInfo = (dealerId: string, market: string) => {
  const numberOfSymbols = dealerId.length;
  if (numberOfSymbols === 9) return dealerId;
  if (numberOfSymbols === 5) {
    return market === US_MARKET ? `USAA${dealerId}` : `CANA${dealerId}`;
  }
  if (numberOfSymbols === 6 && dealerId.startsWith('4')) {
    const rawDealerId = dealerId.slice(0, 1);
    return market === US_MARKET ? `USAA${rawDealerId}` : `CANA${rawDealerId}`;
  }
  if (numberOfSymbols > 6 && dealerId.startsWith('4')) {
    const rawDealerId = dealerId.slice(0, 2);
    return market === US_MARKET ? `USAA${rawDealerId}` : `CANA${rawDealerId}`;
  }
  return market === US_MARKET ? `USAA${dealerId}` : `CANA${dealerId}`;
};
export const prepareDealerIdForFormsApi = (dealerId: string) => {
  const numberOfSymbols = dealerId.length;
  if (numberOfSymbols === 9) return dealerId.slice(4);
  if (numberOfSymbols === 7) return dealerId.slice(2);
  if (numberOfSymbols === 6) return dealerId.slice(1);
  if (numberOfSymbols === 5 && dealerId.startsWith('4')) return dealerId.slice(1);
  return dealerId;
};
